'use client';
import Notification from '@/components/Notification';
import { heroIcons } from '@/constants';
import { useTranslate } from '@tolgee/react';
import { ScrollParallax } from 'react-just-parallax';

interface HomeScrollParallaxProps {}

export default function HomeScrollParallax({}: HomeScrollParallaxProps) {
  const { t } = useTranslate();
  return (
    <>
      <ScrollParallax isAbsolutelyPositioned>
        <ul className="absolute -left-[5.5rem] bottom-[7.5rem] hidden rounded-2xl border border-n-1/10 bg-n-9/40 px-1 py-1 backdrop-blur xl:flex">
          {heroIcons.map((icon, index) => (
            <li className="p-5" key={index}>
              <img src={icon} width={24} height={25} alt={icon} />
            </li>
          ))}
        </ul>
      </ScrollParallax>

      <ScrollParallax isAbsolutelyPositioned>
        <Notification
          className="absolute -right-[5.5rem] bottom-[11rem] hidden w-[18rem] xl:flex"
          title={t('provider_page.hero.notification.title')}
          time={t('provider_page.hero.notification.time')}
        />
      </ScrollParallax>
    </>
  );
}
